import { boldIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Bold = createIcon({
  displayName: 'Bold',
  paths: [
    'M426.667 426.667h128c23.565 0 42.667-19.103 42.667-42.667s-19.102-42.667-42.667-42.667h-128v85.333zM298.667 426.667v-128c0-47.128 38.205-85.333 85.333-85.333h170.667c94.255 0 170.667 76.41 170.667 170.667 0 32.431-9.045 62.75-24.751 88.567 41.259 35.217 67.418 87.603 67.418 146.099 0 106.039-85.961 192-192 192h-192c-47.128 0-85.333-38.204-85.333-85.333v-298.667zM426.667 554.667v128h149.333c35.345 0 64-28.655 64-64s-28.655-64-64-64h-149.333z'
  ],
  canvasPaths: canvasIconPaths(boldIcon)
})
